import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_ATTRACTIONS_PENDING: state => ({
			...state,
			loading: {
				...state.loading,
				attraction: true,
			},
		}),

		FETCH_ATTRACTIONS_FULFILLED: (state, action) => ({
			...state,
			attractionList: action.payload.attractionList,
			attractionData: action.payload.attractionData,
			loading: {
				...state.loading,
				attraction: false,
			},
		}),

		FETCH_EACH_HOTEL_ATTRACTIONS_PENDING: state => ({
			...state,
			...state,
			loading: {
				...state.loading,
				allHotelAttraction: true,
			},
		}),

		FETCH_EACH_HOTEL_ATTRACTIONS_FULFILLED: (state, action) => ({
			...state,
			hotelAttraction: action.payload.hotelAttraction,
			loading: {
				...state.loading,
				attraction: true,
			},
		}),
	},
	{
		attractionList: [],
		attractionData: {},
		hotelAttraction: {},
		loading: {
			attraction: false,
			allHotelAttraction: false,
		},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/attraction.js